import { ISelectValue } from "../../../constants/app.dto";
import { generateRandomID } from "../../../helpers/utilities";
import { Icon } from "../../icons";
import { ControlWrapper } from "../common";
import "./select.style.scss";

export interface ISelect {
  currentValue?: string | number;
  className?: string;
  testId?: string;
  label?: string;
  subLabel?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  hook?: any;
  placeholder?: string;
  disabled?: boolean;
  hasIcon?: boolean;
  hasError?: boolean;
  removedValues?: Partial<ISelectValue>[];
}

export interface SelectProps extends ISelect {
  values: IOption[];
  defaultValue?: string | number;
}

export interface IOption {
  value: string | number;
  label: string;
}

export const Select = (props: SelectProps) => {

  const randomId = generateRandomID();
  const handleDefault = () => { };

  const optionValues = !props?.removedValues ? props.values : props.values.filter((v1) =>
    !props.removedValues?.find((v2) => v2.id === v1.value)
  );

  return (
    <ControlWrapper id={randomId} label={props.label} subLabel={props.subLabel}>
      <div className={`select-wrapper ${props.hasError ? "-error" : ""}`}>
        <select
          {...(props?.hook ?? {})}
          className={`select ${props?.className ?? ""}`}
          data-testid={props?.testId ?? "select-test"}
          onChange={props?.onChange ?? handleDefault}
          placeholder={props?.placeholder}
          value={props?.currentValue}
          disabled={props?.disabled}
          defaultValue={props?.defaultValue}
          id={randomId}
        >
          <option />
          {optionValues.map(({ label, value }: IOption) =>
            <option value={value} key={value} data-label={label}>
              {label}
            </option>
          )}
        </select>
        {props.hasIcon && props.hasError && <Icon type={"error"} />}
      </div>
    </ControlWrapper>
  )
}